/* src/app/private/components/client-center/center-details/center-details.component.scss */
/*# sourceMappingURL=center-details.component.css.map */
